import React from 'react';
import c from 'classnames';

import AudioPlayer, { type AudioPlayerProps } from './AudioPlayer';

import './style.scss';

export interface AudioPlayersProps {
  tracks: AudioPlayerProps[];
  className?: string;
}

const AudioPlayers: React.FC<AudioPlayersProps> = ({
  tracks,
  className,
}) => {
  const classes = c('AudioPlayers', className);

  return (
    <div className={classes}>
      {tracks.map((track) => (
        <AudioPlayer
          key={track.filename}
          source={track.source}
          title={track.title}
          description={track.description}
          filesize={track.filesize}
          filename={track.filename}
        />
      ))}
    </div>
  );
};

export default AudioPlayers;
